export { default } from './PrivateMessageButton';



// WEBPACK FOOTER //
// ./src/components/Messenger/content/PrivateMessageButton/index.js